import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { HttpClient } from '@angular/common/http';
import { Documento, RequestResponseGetAllDocumento, RequestResponseActualizar } from 'src/app/shared/models/documentos/documentos.interface';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { RequestResponse } from 'src/app/shared/models/request-response.interface';
import Swal from 'sweetalert2';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentosService {
  constructor(private http: HttpClient, private auth: AuthService,) { }
  //GetAll_documentos
  traerDocumentos(id: number, mes: number, ano: number): Observable<RequestResponseGetAllDocumento> {
    return this.http
      .get<RequestResponseGetAllDocumento>(`${environment.API}/rrhh/documento/buscartodo/${id}/${mes}/${ano}`)
      .pipe(
        map((res: RequestResponseGetAllDocumento) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }
  //GetAll_adelanto
  traerDocAdelantos(id: number): Observable<RequestResponseGetAllDocumento> {
    return this.http
      .get<RequestResponseGetAllDocumento>(`${environment.API}/rrhh/documento/buscarAdelantoIdTrabajador/${id}`)
      .pipe(
        map((res: RequestResponseGetAllDocumento) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }
  //GetAll_contrato
  traerDocContrato(id: number): Observable<RequestResponseGetAllDocumento> {
    return this.http
      .get<RequestResponseGetAllDocumento>(`${environment.API}/rrhh/documento/buscarContratoIdTrabajador/${id}`)
      .pipe(
        map((res: RequestResponseGetAllDocumento) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }
  //getContrato SE COMENTA, NO EXISTE RUTA EN BACK Y NO SE LLAMA NUNCA LA FUNCION
  // async traerContratoIdTrabajador(id: number): Promise<RequestResponseGetAllDocumento> {
  //   try {
  //     return await this.http.get<RequestResponseGetAllDocumento>(`${environment.API}/rrhh/documento/buscarcontratosrut/${id}`).toPromise();
  //   } catch (error) {
  //     return { success: false, msg: 'Hubo un error al obtener los documentos.' } as RequestResponseGetAllDocumento;
  //   }
  // }

  //GetAll_liquidaciones
  traerDocsLiquidaciones(id: number): Observable<RequestResponseGetAllDocumento> {
    return this.http
      .get<RequestResponseGetAllDocumento>(`${environment.API}/rrhh/documento/buscarLiquidacionIdTrabajador/${id}`)
      .pipe(
        map((res: RequestResponseGetAllDocumento) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }
  //GetAll_prestamo
  traerDocsPrestamos(id: number): Observable<RequestResponseGetAllDocumento> {
    return this.http
      .get<RequestResponseGetAllDocumento>(`${environment.API}/rrhh/documento/buscarPrestamoIdTrabajador/${id}`)
      .pipe(
        map((res: RequestResponseGetAllDocumento) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }
  //GetAll_finiquito
  traerDocFiniquito(id: number): Observable<RequestResponseGetAllDocumento> {
    return this.http
      .get<RequestResponseGetAllDocumento>(`${environment.API}/rrhh/documento/buscarFiniquitoIdTrabajador/${id}`)
      .pipe(
        map((res: RequestResponseGetAllDocumento) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }
  //GetAll_transferencias
  traerDocTransferencia(id: number): Observable<RequestResponseGetAllDocumento> {
    return this.http
      .get<RequestResponseGetAllDocumento>(`${environment.API}/rrhh/documento/buscarTransferenciaIdTrabajador/${id}`)
      .pipe(
        map((res: RequestResponseGetAllDocumento) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }
  //GetAll_Cartas
  traerDocCarta(id: number): Observable<RequestResponseGetAllDocumento> {
    return this.http
      .get<RequestResponseGetAllDocumento>(`${environment.API}/rrhh/documento/buscarCartaIdTrabajador/${id}`)
      .pipe(
        map((res: RequestResponseGetAllDocumento) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }
  //getCarta
  async traerDocCartaAsync(id: number): Promise<RequestResponseGetAllDocumento> {
    try {
      return await this.http.get<RequestResponseGetAllDocumento>(`${environment.API}/rrhh/documento/buscarcartasporid/${id}`).toPromise();
    } catch (error) {
      console.error(error);
      return { success: false, msg: 'Hubo un error al obtener los documentos de las cartas.' } as RequestResponseGetAllDocumento;
    }
  }
  //getFiniquito
  async traerFiniquito(id: number): Promise<RequestResponseGetAllDocumento> {
    try {
      return await this.http.get<RequestResponseGetAllDocumento>(`${environment.API}/rrhh/documento/buscarfiniquitosid/${id}`).toPromise();
    } catch (error) {
      return { success: false, msg: 'Hubo un error al obtener los documentos del finiquito.' } as RequestResponseGetAllDocumento;
    }
  }
  //getLicencia
  async traerLicencia(id: number): Promise<RequestResponseGetAllDocumento> {
    try {
      return await this.http.get<RequestResponseGetAllDocumento>(`${environment.API}/rrhh/documento/buscarlicenciaid/${id}`).toPromise();
    } catch (error) {
      return { success: false, msg: 'Hubo un error al obtener los documentos de licencia.' } as RequestResponseGetAllDocumento;
    }
  }
  //getPermiso
  async traerPermisoAsync(id: number): Promise<RequestResponseGetAllDocumento> {
    try {
      return await this.http.get<RequestResponseGetAllDocumento>(`${environment.API}/rrhh/documento/buscarPermisosId/${id}`).toPromise();
    } catch (error) {
      return { success: false, msg: 'Hubo un al obtener los archivos del permisos.' } as RequestResponseGetAllDocumento;
    }
  }
  //TraerPermiso
  traerPermiso(id: any): Observable<RequestResponse> {
    return this.http
      .get<RequestResponse>(`${environment.API}/rrhh/documento/buscarPermisosId/${id}`)
      .pipe(
        map((res: RequestResponse) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }
  //getVacacion
  async traerVacacion(id: number): Promise<RequestResponseGetAllDocumento> {
    try {
      return await this.http.get<RequestResponseGetAllDocumento>(`${environment.API}/rrhh/documento/buscarvacacionid/${id}`).toPromise();
    } catch (error) {
      return { success: false, msg: 'Hubo un error al obtener los archivos de la vacación.' } as RequestResponseGetAllDocumento;
    }
  }
  //GetAll_Implementos
  traerDocsImplementos(id: number): Observable<RequestResponse> {
    return this.http
      .get<RequestResponse>(`${environment.API}/rrhh/documento/buscarImplementos/${id}`)
      .pipe(
        map((res: RequestResponse) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }
  //GetAll_ImplementosU
  traerDocsImplementosU(id: number): Observable<RequestResponse> {
    return this.http
      .get<RequestResponse>(`${environment.API}/rrhh/documento/buscarImplementosU/${id}`)
      .pipe(
        map((res: RequestResponse) => {
          return res;
        }),
        catchError((err) => this.handlerError(err))
      );
  }
  //eliminarDocumento
  eliminarDocumento(id: number, tipo: string): Observable<RequestResponse> {
    return this.http
      .delete<RequestResponse>(`${environment.API}/rrhh/documento/eliminar/${id}/${tipo}`)
      .pipe(
        map((res: RequestResponse) => {
          return res;
        }),
        catchError((error) => this.handlerError(error))
      );
  }
  //eliminarDocumentoAsync
  async eliminarDocumentoAsync(id: number, tipo: string): Promise<RequestResponse> {
    try {
      const user = this.auth.ObtenerinfoToken();
      return await this.http.delete<RequestResponse>(`${environment.API}/rrhh/documento/eliminar/${id}/${tipo}`).toPromise();
    } catch (error) {
      console.error(error);
      return { success: false, msg: 'Hubo un error al eliminar los registros.' } as RequestResponse;
    }
  }

  private handlerError(err: any): Observable<never> {
    // console.log("EJECUCION DE CODIGO EN CASO DE ERROR O NO ENCONTRAR DATOS");
    let errorMessage = "";
    if (err) {
      errorMessage = `Error: ${err.error.msg}`;
    }
    // this.alert.error_small(err.error.msg);

    Swal.fire({
      icon: 'error',
      title: 'NO SE ENCONRARON REGISTROS ',

    })
    return throwError(errorMessage);
  }
}
